
import type { PropOptions } from 'vue';
import Vue from 'vue';
import MarkIcon from './images/mark.vue.svg';

interface IChoiceVoted {
  value: string;
  text: string;
  isChosen: boolean;
}

export default Vue.extend({
  name: 'WarRoomPostPollChoiceVoted',
  components: {
    MarkIcon,
  },
  props: {
    choice: {
      type: Object,
      required: true,
    } as PropOptions<IChoiceVoted>,
  },
});
